import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  addItem,
  deleteItem,
  downCampo,
  upCampo,
  resetState,
  updateDescricao,
  updateItem,
  updateServicoBoleto,
  updateState,
  updateStatusDisponibilidade,
  updateTitulo,
  updateIdentificadorGRU,
  salvarFormulario,
  editarFormulario
} from "../actions/FormBuilderGRUActions";
import GRUBuilderContainer from "../../../components/formbuilder/container/GRUBuilderContainer";
import { buscarGRU } from "../actions/GRUActions";
import { withRouter } from "react-router";
import { View } from "react-template";

class NewGRU extends View {
  componentWillMount() {
    this.setGRU();
  }

  setGRU() {
    if (this.props.id !== undefined) {
      buscarGRU(
        this.props.id,
        res => {
          let formEditavel = res.data.formEditavel;
          let formEditavel_json = JSON.parse(formEditavel);
          this.props.actions.updateState(formEditavel_json);
        },
        error => {
          this.notifyError("Erro", "Houve um problema ao buscar o formulário");
        }
      );
    } else {
      this.props.actions.resetState();
    }
  }

  render() {
    const apiActions = { salvarFormulario, editarFormulario };
    return (
      <div className="width-100">
        <GRUBuilderContainer
          {...this.props}
          formBuilderGRU={this.props.formBuilderGRU}
          actionsGRUBuilderContainer={this.props.actions}
          actionsHeader={this.props.actionsHeader}
          actionsPreferences={this.props.actionsPreferences}
          actionsItens={this.props.actionsItens}
          actionsFieldTypes={this.props.actionsFieldTypes}
          apiActions={apiActions}
          editId={this.props.id}
          editable={this.props.editable}
          auth={this.props.auth}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    formBuilderGRU: state.FormBuilderGRUReducer,
    auth: state.auth
  };
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ resetState, updateState }, dispatch),
  actionsHeader: bindActionCreators(
    { updateTitulo, updateDescricao },
    dispatch
  ),
  actionsPreferences: bindActionCreators(
    {
      updateStatusDisponibilidade,
      updateServicoBoleto,
      updateIdentificadorGRU
    },
    dispatch
  ),
  actionsItens: bindActionCreators(
    { updateItem, deleteItem, downCampo, upCampo },
    dispatch
  ),
  actionsFieldTypes: bindActionCreators({ addItem }, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(NewGRU));



// WEBPACK FOOTER //
// ./src/view/gru/new/NewGRU.js